import React, {Component} from 'react'
import Const from '../Const'
import {observer, inject} from 'mobx-react'
import ShowText from './ShowText'

@inject("uiState") @observer
class ShowTextBinder extends Component{

  render(){
    const {showKey, toastStyle} = this.props.uiState
    const props = {
      showText: Const.showText.get(showKey)
      ,showAuthor: Const.showAuthor.get(showKey)
      ,toastStyle: Const.defaultStyle.get(toastStyle)
    }
    return (
      <ShowText {...props}></ShowText>
    )
  }
}

export default ShowTextBinder



// WEBPACK FOOTER //
// ./src/textModule/ShowTextBinder.js